import { useCallback, useEffect, useRef, useSyncExternalStore } from 'react';

export const useMatchMedia = (query: string, onChange?: (matches: boolean) => void): boolean => {
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const subscribe = useCallback(
    (callback: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', callback);
      return () => {
        mql.removeEventListener('change', callback);
      };
    },
    [query],
  );

  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query]);

  // SSR: server snapshot은 항상 false (window 없음)
  const getServerSnapshot = useCallback(() => false, []);

  const matches = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  // onChange: 초기값 포함 + 변경 시마다 호출 (기존 동작 유지)
  const prevMatchesRef = useRef<boolean | undefined>(undefined);
  useEffect(() => {
    if (prevMatchesRef.current !== matches) {
      onChangeRef.current?.(matches);
    }
    prevMatchesRef.current = matches;
  }, [matches]);

  return matches;
};
